import Link from './Link'

export default Link as any
